import React, { useState } from 'react';
import { buildPageUrl, NeuroMessage, useUser, RenderOnlyFor, useAnalytics } from '@ignitesales/neuro-application';
import ContactFormModal from '../ContactFormModal.jsx';
import PromoModal from '../PromoModal.jsx';
import Footer from '../Footer.jsx';
import Product from "../Product.jsx";
import Header from '../Header.jsx';
import SocialActionsBar from '../SocialActionsBar.jsx';
import ProductSelection from '../ProductSelection.jsx';

function SummaryPage({ componentClass, productsList }) {
    let products = [];
    let addOnProducts = [];
    const { actionCompleted } = useAnalytics();

    const [showContactForm, setShowContactForm] = useState(false);
    const [showPromoModal, setShowPromoModal] = useState(false);
    const ctaHandlers = {
        setShowContactForm
    };

    const { uuid } = useUser();

    const isCompanionProduct = (product) => product.groupType === 'companion';

    productsList.forEach( p => isCompanionProduct(p) ? addOnProducts.push(p) : products.push(p));

    const detailsUrl = buildPageUrl({
        type: 'details',
        uuid
    });

    const onPrintClick = () => {
        if (detailsUrl) {
            window.open(detailsUrl);
        }
    };

    const isRecommended = productId => productsList.some( p => p.id === productId );

    const getProductsFromCompanion = companionId => {
        let coreProducts = [];
        productsList.forEach( product => product.addOns.some( addOn => addOn.id === companionId ) ? coreProducts.push(product) : null);
        return coreProducts;
    };

    const onPromoButtonClick = () => {
        setShowPromoModal(true);
        actionCompleted({ actionName: 'promoButtonClicked' });
    };

    const renderPromoButton = () => {
        return (
            <div className={`${componentClass}__promo-button`}>
                <button className="btn btn-primary" onClick={() => onPromoButtonClick()}>
                    <span><NeuroMessage id='promo.button.title' /><br/><NeuroMessage id='promo.button.action' /></span>
                </button>
            </div>
        );
    }

    return (
        <div className={componentClass} id={componentClass}>
            <Header isSummaryPage showContactForm={() => setShowContactForm(true)} />
            <div className="container">
                <SocialActionsBar detailsUrl={detailsUrl} />
                <div className={`${componentClass}__header`}>
                    <div>
                        <NeuroMessage id="summary.title" tagName="h1" />
                        <NeuroMessage id="summary.subtext" tagName="p" />
                    </div>
                </div>

                <div className={`${componentClass}__products`}>
                    <div className="products-label"><NeuroMessage id="products" /></div>
                    {products.map(p => <Product key={p.id} ctaHandlers={ctaHandlers} product={p} isRecommended={isRecommended} />)}
                </div>

                <div className={`${componentClass}__products add-ons`}>
                    <div className="products-label"><NeuroMessage id="companions" /></div>
                    {addOnProducts.map(p => <Product key={p.id} product={p} isAddOn={true} getProductsFromCompanion={getProductsFromCompanion}/>)}
                </div>

                <div className={`${componentClass}__recommendation-disclosure`}>
                    <NeuroMessage id="recommendationDisclosure" tagName="ol" />
                </div>

                {renderPromoButton()}

                <RenderOnlyFor forSummaryPage={true}>
                    <div className={`${componentClass}__actions`}>
                        <div className="contact-me-container">
                            <button className="btn btn-primary" disabled onClick={() => setShowContactForm(true)}>
                                <NeuroMessage id='summary.completeBtn' />
                            </button>
                        </div>
                        <div className="other-actions-container">
                            <button className="btn btn-primary" onClick={onPrintClick}>
                                <NeuroMessage id='summary.print' />
                            </button>
                            <a className="btn btn-primary" href="https://www.renasantbank.com/locations" target="_blank"><NeuroMessage id='summary.visitABranch' /></a>
                        </div>
                    </div>
                </RenderOnlyFor>
                <Footer isSummaryPage />
            </div>
            <ContactFormModal
                isOpen={showContactForm}
                onClose={() => setShowContactForm(false)}
                onComplete={() => setShowContactForm(false)}
                children={<ProductSelection products={products}/>}
            />
            <PromoModal
                isOpen={showPromoModal}
                onClose={() => setShowPromoModal(false)}
            />
        </div>
    );
}

export default SummaryPage;

